import { useQuery, useQueryClient } from '@tanstack/react-query';

import { RateRule } from '~/components/Vendors/Chains/components/RateRuleModal';

import ReservationService from '~/services/ReservationService';

interface ChainRateRulesResponse {
  status: number;
  result: RateRule[];
}

export const chainRateRuleQueryKeys = {
  all: ['chains', 'rateRules'] as const,
  list: (chainId: string) => [...chainRateRuleQueryKeys.all, chainId] as const,
};

export function useGetChainRateRules(chainId: string) {
  return useQuery<RateRule[]>({
    queryKey: chainRateRuleQueryKeys.list(chainId),
    queryFn: async () => {
      const res: ChainRateRulesResponse = await ReservationService.getChainRateRules(chainId);
      return res.result ?? [];
    },
    enabled: !!chainId,
  });
}

export function useInvalidateChainRateRules() {
  const queryClient = useQueryClient();
  return (chainId: string) => queryClient.invalidateQueries({ queryKey: chainRateRuleQueryKeys.list(chainId) });
}
